import Vue from 'vue'
import VueRouter from 'vue-router'
import envs from '@/envs'

import Layout from '@/layout/layout.vue'
import Login from '@/layout/login/Login.vue'
import Logout from '@/layout/login/Logout'

import pageNotFound from '@/components/common/error/404'

import DwgViewer from '../DwgViewer'

import {
  getToken
} from '@/utils/token'

import hycot from './modules/hycot'
import test from './modules/test/jde'
import test2 from './modules/test/yis'
import { openMenu } from '@/api/system/userManage'

// import help from './modules/help' //환경설정>도움말
//import layoutSample from './modules/help/layoutSample' //환경설정>도움말>레이아웃샘플
//import uiExample from './modules/help/uiExample' //환경설정>도움말>UI예제

//import system from './modules/system' //시스템관리

Vue.use(VueRouter)

const createRouter = () => new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/pageNotFound',
      component: pageNotFound,
    },
    {
      path: '/',
      redirect: '/pageNotFound',
      component: Layout,
      children: [
        ...hycot,
        // dashboard,
        test,
        test2
        // help,
        /*layoutSample,
        uiExample*/
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/DwgViewer',
      name: 'DwgViewer',
      component: DwgViewer
    }
  ]
})

let router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach(function (to, from, next) {
  // console.log('router to : ',to)

  //-------------------Login History----------------------------
  let params = {

    menuId: to.meta.menu_id,
    prtId: to.meta.prt_id,
    jspNm: to.meta.menu_code,
    userId: to.meta.user_id,
  } 
  
  openMenu(params).then(res => {    
      })

  //-----------------------------------------------    
  if (!to.matched.length) {
    //next('/pageNotFound');
    next('/home0000');
  } else {
    let loginWhiteList = [...envs.framework.whiteList]
    // 세션 적용 되면 이곳 로직 변경
    if (
      !loginWhiteList.some(path => {
        return path === to.path
      })
    ) {
      if (to.query.id) {
        console.log('단독 페이지호출시 next(/login)되던것을 막음')
      } else {
        if (!getToken() && to.path !== '/login') {
          next('/login')
          return
        } else {
          if (!getToken() && to.path !== '/blank' && to.path !== '/not-found') {
            next('/blank')
            return
          }
        }
      }
    }
    next()
  }
})

//네비게이션 가드(전역 가드) : 사용자의 인증 정보가 없으면 특정 페이지에 접근하지 못하게 할 때 사용하는 기술입니다.
//router.beforeEach( function (to, from, next) {
//to : 이동할 url
//from : 현재 url
//next : to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수

//to: 이동할 url에 해당하는 라우팅 객체
//console.log("routing 1 : '" + to.path + "'" );
//console.log("routing 2 : '" + from.path + "'" );

//store.dispatch('SetHeaderUse', to.meta.headerView !== false)

// if (to.matched.some(function (routeInfo)
// {
//   console.log("routeInfo.meta.authRequired: " + routeInfo.meta.authRequired)
//     return routeInfo.meta.authRequired;
// })) {
//     next('/login')
//     return

// } else {
//     console.log("routing success : '" + to.path + "'" )
//     next();
//     return
// }

//})

export default router
